import DefaultCharts, { IDefaultChartsProps } from "./DefaultCharts";
import { withRouter } from "react-router-dom";
import {observer} from "mobx-react";

export default withRouter<IDefaultChartsProps, any>(observer(DefaultCharts));
